function getModelInfo(model_id, modelArray) {
    for (let i = 0; i < modelArray.length; i++) {
      if (modelArray[i].model_id === model_id) {
        return { name: modelArray[i].name, title: modelArray[i].title };
      }
    }
    return null; 
}

export default getModelInfo